<div class="text-center px-20px not-found__content-container">
  <h1>Page not found</h1>

  <div class="fc-muted mt-20px">This is a 404 error</div>

  <div class="mt-30px">Sorry! If this is a problem on our end, we've been notified and are working to fix it.</div>
</div>
